import { USER_TYPE } from '@/config/CONSTANTS';
import { GETTER } from './CONSTANTS';

export default {
  [GETTER.AUTHENTICATED](state) {
    return Boolean(state.token);
  },
  [GETTER.USER_TYPE](state) {
    const { current_realtor_type: currentRealtorType = USER_TYPE.SUPPLY_AND_DEMAND } = state.data;
    return currentRealtorType;
  },
  [GETTER.CONTACT_PHOTO](state) {
    const { contact_photo: contactPhoto = '' } = state.data;
    return contactPhoto;
  },
  [GETTER.INITIALS](state) {
    const { first_name: firstName = '', last_name: lastName = '' } = state.data;

    const lastNameInitial = lastName.charAt(0);

    if (!firstName) {
      return lastNameInitial;
    }

    const firstNameInitial = firstName.charAt(0);

    if (!lastName) {
      return firstNameInitial;
    }

    return `${firstNameInitial}${lastNameInitial}`;
  },
  [GETTER.FULL_NAME](state) {
    const { first_name: firstName = '', last_name: lastName = '', salutation } = state.data;

    if (!firstName) {
      return `${salutation} ${lastName}`;
    }

    return `${firstName} ${lastName}`;
  },
  [GETTER.FORMAL_NAME](state) {
    const { first_name: firstName = '', last_name: lastName = '', title, salutation } = state.data;
    let formalName = lastName;

    if (title) {
      formalName = `${title} ${formalName}`;
    }

    if (salutation) {
      formalName = `${salutation} ${formalName}`;
    }

    if (firstName && formalName === lastName) {
      formalName = `${firstName} ${lastName}`;
    }

    return formalName;
  },
};
